import { AxiosRequestConfig } from 'axios';
import { apmMonitor } from '@/service/apmMonitor';
import { HttpClient } from '../client';

/**
 * APM Trace 拦截器
 * 将 ELK RUM 的 trace ID 添加到请求头中
 */
export class ApmTraceInterceptor {

    /**
     * 请求拦截器 - 添加 trace ID 到请求头
     */
    public requestInterceptor( config: AxiosRequestConfig ): AxiosRequestConfig {

        try {

            const transaction = apmMonitor.getCurrentTransaction();
            
            if ( transaction ) {

                // 获取 trace ID（transaction.id 是 elastic APM 的 transaction ID）
                const traceId = transaction['trace_id'];
                
                if ( traceId ) {

                    // 添加到请求头
                    if ( !config.headers ) {

                        config.headers = {};
                    
                    }
                    
                    config.headers['x-prid'] = traceId;
                
                }
            
            }
        
        } catch ( error ) {

            // 捕获错误，不影响正常请求
            console.warn( 'Failed to add APM trace ID to request header:', error );
        
        }

        return config;
    
    }

    /**
     * 请求错误拦截器
     */
    public requestOnError( error: unknown ): Promise<unknown> {

        return Promise.reject( error );
    
    }

    /**
     * 注册拦截器到 HttpClient
     */
    public static register( httpClient: HttpClient ): void {

        const plugin = new ApmTraceInterceptor();
        
        httpClient._client.interceptors.request.use(
            plugin.requestInterceptor.bind( plugin ),
            plugin.requestOnError.bind( plugin )
        );
    
    }

}
